
// ? we need the 

import { images } from "./productImages";


// ! CHANGES HERE NEED TO REFLECT FIRST IN BACKEND SIDE, THERE IS A menu_items 
// ! YOU WILL BE USING http://0.0.0.0:8000/menu_items_update/

// export default MenuImages;



export const prodDescri = {
  main: {
    title: "A Wide Range of Products for Makers",
    intro:
      "From microcontrollers to sensors, motors, and tools, we bring together everything you need to design, prototype, and build real projects. Whether you’re experimenting, learning, or shipping a finished build, our catalog is organized to help you find the right components fast.",
    image:images.boards_controllers,
    },

  boards_controllers: {
    title: "Boards & Controllers",
    intro:
      "The brain of your projects. Microcontroller boards, core modules, expansion shields, and programming tools to power anything from simple prototypes to advanced systems.",
    image:images.boards_controllers,
    },

  sensors: {
    title: "Sensors",
    intro:
      "Turn the physical world into data. Environmental, motion, distance, biometric, magnetic, and liquid sensors to measure, detect, and react to real-world conditions.",
    image:images.sensors,
    },

  actuators_motion: {
    title: "Actuators & Motion",
    intro:
      "Make things move. DC motors, servos, steppers, pumps, fans, and mechanical parts to bring motion and control into your designs.",
    image:images.actuators_motion,
    },

  power_energy: {
    title: "Power & Energy",
    intro:
      "Reliable power, done right. Batteries, charging modules, regulators, protection circuits, and solar solutions to keep your projects safe and stable.",
    image:images.power_energy,
    },

  displays_indicators: {
    title: "Displays & Indicators",
    intro:
      "Show what’s happening. OLED, TFT, LCD displays, LEDs, matrices, and meters to visualize data, status, and interaction.",
    image:images.displays_indicators,
},

  communication_wireless: {
    title: "Communication & Wireless",
    intro:
      "Connect your projects. Wi-Fi, Bluetooth, RF, NFC, GPS, and audio modules to enable wireless communication and smart connectivity.",
    image:images.communication_wireless,
},

  components_prototyping: {
    title: "Components & Prototyping",
    intro:
      "Build and iterate faster. Passive and active components, breadboards, connectors, switches, enclosures, and mechanical hardware for rapid prototyping.",
    image:images.components_prototyping,
},

  tools_workshop: {
    title: "Tools & Workshop",
    intro:
      "Everything around the build. Soldering equipment, hand tools, consumables, assembly aids, and organization solutions for a clean and efficient workspace.",
    image:images.tools_workshop,
},
} satisfies Record<string, {
  title: string;
  intro: string;
  image: string;
}>;




export const menu_items = {
  "menu_items": [
    { "id": "boards_controllers", "slug": "boards-controllers", "label": "Boards & controllers", "icon": "microcontrollers", "order": 1 },
    { "id": "sensors", "slug": "sensors", "label": "Sensors", "icon": "sensors", "order": 2 },
    { "id": "actuators_motion", "slug": "actuators-motion", "label": "Actuators & Motion", "icon": "motors", "order": 3 },
    { "id": "power_energy", "slug": "power-energy", "label": "Power & Energy", "icon": "power", "order": 4 },
    { "id": "displays_indicators", "slug": "displays-indicators", "label": "Displays & Indicators", "icon": "displays", "order": 5 },
    { "id": "communication_wireless", "slug": "communication-wireless", "label": "Communication & Wireless", "icon": "networking", "order": 6 },
    { "id": "components_prototyping", "slug": "components-prototyping", "label": "Components & Prototyping", "icon": "components", "order": 7 },
    { "id": "tools_workshop", "slug": "tools-workshop", "label": "Tools & Workshop", "icon": "tools", "order": 8 }
  ],
  "subcategories": [
    { "id": "microcontroller_boards", "parent": "boards_controllers", "slug": "microcontroller-boards", "label": "Microcontroller Boards" },
    { "id": "core_modules", "parent": "boards_controllers", "slug": "core-modules", "label": "Core Modules" },
    { "id": "expansion_shields", "parent": "boards_controllers", "slug": "expansion-shields", "label": "Expansion & Shields" },
    { "id": "programming_debug", "parent": "boards_controllers", "slug": "programming-debug", "label": "Programming & Debug" },

    { "id": "environmental_sensors", "parent": "sensors", "slug": "environmental", "label": "Environmental" },
    { "id": "motion_presence", "parent": "sensors", "slug": "motion-presence", "label": "Motion & Presence" },
    { "id": "distance_position", "parent": "sensors", "slug": "distance-position", "label": "Distance & Position" },
    { "id": "biometric_human", "parent": "sensors", "slug": "biometric-human", "label": "Biometric & Human" },
    { "id": "magnetic_orientation", "parent": "sensors", "slug": "magnetic-orientation", "label": "Magnetic & Orientation" },
    { "id": "liquid_flow", "parent": "sensors", "slug": "liquid-flow", "label": "Liquid & Flow" },

    { "id": "dc_motors", "parent": "actuators_motion", "slug": "dc-motors", "label": "DC Motors" },
    { "id": "gear_motors", "parent": "actuators_motion", "slug": "gear-motors", "label": "Gear Motors" },
    { "id": "servo_motors", "parent": "actuators_motion", "slug": "servo-motors", "label": "Servo Motors" },
    { "id": "stepper_motors", "parent": "actuators_motion", "slug": "stepper-motors", "label": "Stepper Motors" },
    { "id": "pumps_fans", "parent": "actuators_motion", "slug": "pumps-fans", "label": "Pumps & Fans" },
    { "id": "mechanical_motion", "parent": "actuators_motion", "slug": "mechanical-motion", "label": "Mechanical Motion" },

    { "id": "batteries", "parent": "power_energy", "slug": "batteries", "label": "Batteries" },
    { "id": "battery_holders", "parent": "power_energy", "slug": "battery-holders", "label": "Battery Holders" },
    { "id": "charging_modules", "parent": "power_energy", "slug": "charging-modules", "label": "Charging Modules" },
    { "id": "power_regulation", "parent": "power_energy", "slug": "power-regulation", "label": "Power Regulation" },
    { "id": "solar_power", "parent": "power_energy", "slug": "solar-power", "label": "Solar Power" },
    { "id": "protection_monitoring", "parent": "power_energy", "slug": "protection-monitoring", "label": "Protection & Monitoring" },

    { "id": "oled_displays", "parent": "displays_indicators", "slug": "oled", "label": "OLED Displays" },
    { "id": "tft_displays", "parent": "displays_indicators", "slug": "tft", "label": "TFT Displays" },
    { "id": "lcd_displays", "parent": "displays_indicators", "slug": "lcd", "label": "LCD Displays" },
    { "id": "led_indicators", "parent": "displays_indicators", "slug": "led-indicators", "label": "LED Indicators" },
    { "id": "led_matrices_drivers", "parent": "displays_indicators", "slug": "led-matrices-drivers", "label": "LED Matrices & Drivers" },
    { "id": "meters", "parent": "displays_indicators", "slug": "meters", "label": "Meters" },

    { "id": "wifi_bluetooth", "parent": "communication_wireless", "slug": "wifi-bluetooth", "label": "Wi-Fi & Bluetooth" },
    { "id": "rf_subghz", "parent": "communication_wireless", "slug": "rf-subghz", "label": "RF & Sub-GHz" },
    { "id": "nfc_rfid", "parent": "communication_wireless", "slug": "nfc-rfid", "label": "NFC & RFID" },
    { "id": "gps", "parent": "communication_wireless", "slug": "gps", "label": "GPS" },
    { "id": "audio_voice", "parent": "communication_wireless", "slug": "audio-voice", "label": "Audio & Voice" },

    { "id": "passive_components", "parent": "components_prototyping", "slug": "passive-components", "label": "Passive Components" },
    { "id": "active_components", "parent": "components_prototyping", "slug": "active-components", "label": "Active Components" },
    { "id": "prototyping_boards", "parent": "components_prototyping", "slug": "prototyping-boards", "label": "Prototyping Boards" },
    { "id": "connectors_wiring", "parent": "components_prototyping", "slug": "connectors-wiring", "label": "Connectors & Wiring" },
    { "id": "switches_inputs", "parent": "components_prototyping", "slug": "switches-inputs", "label": "Switches & Inputs" },
    { "id": "mechanical_hardware", "parent": "components_prototyping", "slug": "mechanical-hardware", "label": "Mechanical Hardware" },
    { "id": "enclosures_mounting", "parent": "components_prototyping", "slug": "enclosures-mounting", "label": "Enclosures & Mounting" },

    { "id": "soldering_equipment", "parent": "tools_workshop", "slug": "soldering-equipment", "label": "Soldering Equipment" },
    { "id": "soldering_consumables", "parent": "tools_workshop", "slug": "soldering-consumables", "label": "Soldering Consumables" },
    { "id": "hand_tools", "parent": "tools_workshop", "slug": "hand-tools", "label": "Hand Tools" },
    { "id": "assembly_aids", "parent": "tools_workshop", "slug": "assembly-aids", "label": "Assembly Aids" },
    { "id": "adhesives_insulation", "parent": "tools_workshop", "slug": "adhesives-insulation", "label": "Adhesives & Insulation" },
    { "id": "organization", "parent": "tools_workshop", "slug": "organization", "label": "Organization" }
  ]
}




// const newMenu = {
//   "menu_version": "1.0.0",
//   "updated_at": "2026-01-20T00:00:00Z",
//   "categories": [
//     {
//       "id": "boards_controllers",
//       "slug": "boards-controllers",
//       "label": "Boards & controllers",
//       "icon": "cpu",
//       "order": 1,
//       "subcategories": [
//         {
//           "id": "microcontroller_boards",
//           "slug": "microcontroller-boards",
//           "label": "Microcontroller Boards"
//         },
//         {
//           "id": "core_modules",
//           "slug": "core-modules",
//           "label": "Core Modules"
//         },
//         {
//           "id": "expansion_shields",
//           "slug": "expansion-shields",
//           "label": "Expansion & Shields"
//         },
//         {
//           "id": "programming_debug",
//           "slug": "programming-debug",
//           "label": "Programming & Debug"
//         }
//       ]
//     },

//     {
//       "id": "sensors",
//       "slug": "sensors",
//       "label": "Sensors",
//       "icon": "activity",
//       "order": 2,
//       "subcategories": [
//         {
//           "id": "environmental_sensors",
//           "slug": "environmental",
//           "label": "Environmental"
//         },
//         {
//           "id": "motion_presence",
//           "slug": "motion-presence",
//           "label": "Motion & Presence"
//         },
//         {
//           "id": "distance_position",
//           "slug": "distance-position",
//           "label": "Distance & Position"
//         },
//         {
//           "id": "biometric_human",
//           "slug": "biometric-human",
//           "label": "Biometric & Human"
//         },
//         {
//           "id": "magnetic_orientation",
//           "slug": "magnetic-orientation",
//           "label": "Magnetic & Orientation"
//         },
//         {
//           "id": "liquid_flow",
//           "slug": "liquid-flow",
//           "label": "Liquid & Flow"
//         }
//       ]
//     },

//     {
//       "id": "actuators_motion",
//       "slug": "actuators-motion",
//       "label": "Actuators & Motion",
//       "icon": "settings",
//       "order": 3,
//       "subcategories": [
//         {
//           "id": "dc_motors",
//           "slug": "dc-motors",
//           "label": "DC Motors"
//         },
//         {
//           "id": "gear_motors",
//           "slug": "gear-motors",
//           "label": "Gear Motors"
//         },
//         {
//           "id": "servo_motors",
//           "slug": "servo-motors",
//           "label": "Servo Motors"
//         },
//         {
//           "id": "stepper_motors",
//           "slug": "stepper-motors",
//           "label": "Stepper Motors"
//         },
//         {
//           "id": "pumps_fans",
//           "slug": "pumps-fans",
//           "label": "Pumps & Fans"
//         },
//         {
//           "id": "mechanical_motion",
//           "slug": "mechanical-motion",
//           "label": "Mechanical Motion"
//         }
//       ]
//     },

//     {
//       "id": "power_energy",
//       "slug": "power-energy",
//       "label": "Power & Energy",
//       "icon": "battery",
//       "order": 4,
//       "subcategories": [
//         {
//           "id": "batteries",
//           "slug": "batteries",
//           "label": "Batteries"
//         },
//         {
//           "id": "battery_holders",
//           "slug": "battery-holders",
//           "label": "Battery Holders"
//         },
//         {
//           "id": "charging_modules",
//           "slug": "charging-modules",
//           "label": "Charging Modules"
//         },
//         {
//           "id": "power_regulation",
//           "slug": "power-regulation",
//           "label": "Power Regulation"
//         },
//         {
//           "id": "solar_power",
//           "slug": "solar-power",
//           "label": "Solar Power"
//         },
//         {
//           "id": "protection_monitoring",
//           "slug": "protection-monitoring",
//           "label": "Protection & Monitoring"
//         }
//       ]
//     },

//     {
//       "id": "displays_indicators",
//       "slug": "displays-indicators",
//       "label": "Displays & Indicators",
//       "icon": "monitor",
//       "order": 5,
//       "subcategories": [
//         {
//           "id": "oled_displays",
//           "slug": "oled",
//           "label": "OLED Displays"
//         },
//         {
//           "id": "tft_displays",
//           "slug": "tft",
//           "label": "TFT Displays"
//         },
//         {
//           "id": "lcd_displays",
//           "slug": "lcd",
//           "label": "LCD Displays"
//         },
//         {
//           "id": "led_indicators",
//           "slug": "led-indicators",
//           "label": "LED Indicators"
//         },
//         {
//           "id": "led_matrices_drivers",
//           "slug": "led-matrices-drivers",
//           "label": "LED Matrices & Drivers"
//         },
//         {
//           "id": "meters",
//           "slug": "meters",
//           "label": "Meters"
//         }
//       ]
//     },

//     {
//       "id": "communication_wireless",
//       "slug": "communication-wireless",
//       "label": "Communication & Wireless",
//       "icon": "wifi",
//       "order": 6,
//       "subcategories": [
//         {
//           "id": "wifi_bluetooth",
//           "slug": "wifi-bluetooth",
//           "label": "Wi-Fi & Bluetooth"
//         },
//         {
//           "id": "rf_subghz",
//           "slug": "rf-subghz",
//           "label": "RF & Sub-GHz"
//         },
//         {
//           "id": "nfc_rfid",
//           "slug": "nfc-rfid",
//           "label": "NFC & RFID"
//         },
//         {
//           "id": "gps",
//           "slug": "gps",
//           "label": "GPS"
//         },
//         {
//           "id": "audio_voice",
//           "slug": "audio-voice",
//           "label": "Audio & Voice"
//         }
//       ]
//     },

//     {
//       "id": "components_prototyping",
//       "slug": "components-prototyping",
//       "label": "Components & Prototyping",
//       "icon": "layers",
//       "order": 7,
//       "subcategories": [
//         {
//           "id": "passive_components",
//           "slug": "passive-components",
//           "label": "Passive Components"
//         },
//         {
//           "id": "active_components",
//           "slug": "active-components",
//           "label": "Active Components"
//         },
//         {
//           "id": "prototyping_boards",
//           "slug": "prototyping-boards",
//           "label": "Prototyping Boards"
//         },
//         {
//           "id": "connectors_wiring",
//           "slug": "connectors-wiring",
//           "label": "Connectors & Wiring"
//         },
//         {
//           "id": "switches_inputs",
//           "slug": "switches-inputs",
//           "label": "Switches & Inputs"
//         },
//         {
//           "id": "mechanical_hardware",
//           "slug": "mechanical-hardware",
//           "label": "Mechanical Hardware"
//         },
//         {
//           "id": "enclosures_mounting",
//           "slug": "enclosures-mounting",
//           "label": "Enclosures & Mounting"
//         }
//       ]
//     },

//     {
//       "id": "tools_workshop",
//       "slug": "tools-workshop",
//       "label": "Tools & Workshop",
//       "icon": "tool",
//       "order": 8,
//       "subcategories": [
//         {
//           "id": "soldering_equipment",
//           "slug": "soldering-equipment",
//           "label": "Soldering Equipment"
//         },
//         {
//           "id": "soldering_consumables",
//           "slug": "soldering-consumables",
//           "label": "Soldering Consumables"
//         },
//         {
//           "id": "hand_tools",
//           "slug": "hand-tools",
//           "label": "Hand Tools"
//         },
//         {
//           "id": "assembly_aids",
//           "slug": "assembly-aids",
//           "label": "Assembly Aids"
//         },
//         {
//           "id": "adhesives_insulation",
//           "slug": "adhesives-insulation",
//           "label": "Adhesives & Insulation"
//         },
//         {
//           "id": "organization",
//           "slug": "organization",
//           "label": "Organization"
//         }
//       ]
//     }
//   ]
// }
